<template>
  <b-table
    :data="data"
    :loading="isLoading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="active" label="Ativo" numeric>
        <b-icon
          v-if="props.row.active"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
      </b-table-column>

      <b-table-column label="Título">{{ props.row.title }}</b-table-column>

      <b-table-column label="Opções">
        <router-link
          :to="`${props.row.id}/questions`"
          tag="button"
          type="button"
          v-app-button.icon-only
          title="Perguntas"
          v-tooltip.bottom="'Perguntas'"
        >
          <b-icon size="is-small" icon="help"></b-icon>
        </router-link>
        <router-link
          :to="`${props.row.id}/edit`"
          tag="button"
          type="button"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </router-link>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import TrainingService from '@/services/training.service';

export default {
  name: 'trainings-table',
  data: () => {
    return {
      isLoading: true,
      data: [],
      total: 0,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      TrainingService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Treinamentos.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onClickDeleteTraining(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Treinamento',
        message:
          'Tem certeza que deseja <b>excluir</b> este treinamento? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Treinamento',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteTraining(id),
      });
    },
    deleteTraining(id) {
      TrainingService.delete(id)
        .then(() => {
          this.toastify('Treinamento excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Treinamento.',
            'error'
          );
        });
    },
    onPageChange(page) {
      (this.page = page), this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
